import { render } from "./ViewFaq.vue?vue&type=template&id=0accbdec&ts=true"
import script from "./ViewFaq.vue?vue&type=script&lang=ts"
export * from "./ViewFaq.vue?vue&type=script&lang=ts"

import "./ViewFaq.vue?vue&type=style&index=0&id=0accbdec&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__